import {FaBoxOpen} from "react-icons/fa";
import {DiAndroid} from "react-icons/di";
import {HiRocketLaunch} from "react-icons/hi2";
import {GrSystem} from "react-icons/gr";
import {TbPasswordUser, TbTestPipe} from "react-icons/tb";
import {PiPackageBold} from "react-icons/pi";
import React from "react";

export const stepContentMap = {
    unboxingAndPrepare: {
        id: 0,
        title: "Ποιοτικός Έλεγχος Συσκευής - Προετοιμασία",
        icon: <FaBoxOpen size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Άνοιγμα Συσκευασίας</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Ανοίγουμε προσεκτικά με το ειδικό κοπίδι σχίζοντας την πλαϊνή πάνω πλευρά της ζελατίνας στην εγκοπή της συσκευασίας.</div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step1/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Έλεγχος Περιεχομένων</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Αφαιρούμε όλα τα περιεχόμενα της συσκευασίας και ελέγχουμε ότι υπάρχουν ΌΛΑ:<br /><span style={{fontWeight: 'bold'}}>Συσκευή, Φορτιστής, Καλώδιο Φόρτισης, Χαρτί Θερμικού Εκτυπωτή, Οδηγίες Χρήσης</span></div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step2/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Έλεγχος Φόρτισης</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Βγάζουμε τον φορτιστή από την συσκευασία και τον συνδέουμε στο ρεύμα με την συσκευή. Επιβεβαιώνουμε ότι φορτίζει με την αντίστοιχη ένδειξη στην οθόνη.</div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step3/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Τοποθέτηση Χαρτιού Εκτύπωσης</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Ανοίγουμε το πορτοκαλί καπάκι στο μπροστά μέρος της συσκευής και τοποθετούμε το χαρτί εκτύπωσης με την σωστή πλευρά και ξανακλείνουμε το καπάκι.<br /><span style={{fontWeight: 'bold'}}>(Το χαρτί να κοιτάει προς τα κάτω)</span></div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step4/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Τοποθέτηση Αυτοκόλλητων Primer</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Τοποθετούμε τα αυτοκόλλητα όπως υποδεικνύονται στις φωτογραφίες:<br />
                    Ένα πάνω στο καπάκι<span style={{fontWeight: 'bold'}}> (1η φώτο SUNMI V2S)</span>.<br />
                    Ένα πίσω από τον εκτυπωτή στο μαύρο πλαίσιο<span style={{fontWeight: 'bold'}}> (2η φώτο SUNMI V2S)</span>.<br />
                    Δύο πάνω από την οθόνη στο μαύρο πλαίσιο<span style={{fontWeight: 'bold'}}> (3η φώτο SUNMI V3 MIX)</span>.<br />
                </div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step5/1.png"}, {original: "assets/images/primer-pos-steps/unboxingAndPrepare/step5/2.png"}, {original: "assets/images/primer-pos-steps/unboxingAndPrepare/step5/3.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Εγκατάσταση SIM</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Αποσυνδέουμε τον φορτιστή και ανοίγουμε το πίσω καπάκι της συσκευής από την εγκοπή.<span style={{fontWeight: 'bold'}}> (1η φώτο)</span> <br/>
                    Αφαιρούμε το καπάκι και την μπαταρία από το εσωτερικό.<span style={{fontWeight: 'bold'}}> (2η φώτο)</span><br/>
                    Τοποθετούμε την SIM στο σημείο και με τον τρόπο που υποδεικνύεται.<span style={{fontWeight: 'bold'}}> (3η φώτο)</span>
                </div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step6/1.png"}, {original: "assets/images/primer-pos-steps/unboxingAndPrepare/step6/2.png"}, {original: "assets/images/primer-pos-steps/unboxingAndPrepare/step6/3.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Εκκίνηση Συσκευής</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Επανατοποθετούμε την μπαταρία και κλείνουμε το πίσω καπάκι.<br/>
                    Επανασυνδέουμε τον φορτιστή με την συσκευή.<br/>
                    Ενεργοποιούμε την συσκευή πατώντας παρατεταμένα το πάνω κουμπί από την δεξιά πλαϊνή πλευρά της συσκευής.
                </div>,
                images: [{original: "assets/images/primer-pos-steps/unboxingAndPrepare/step7/1.png"}]
            },
        ]
    },
    setupDevice: {
        id: 1,
        title: "Αρχική Παραμετροποίηση Συσκευής",
        icon: <DiAndroid size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Καλωσόρισμα και Επιλογή Γλώσσας</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Αφού ανοίξει πλήρως η συσκευή πατάμε το κουμπί με το βελάκι στην οθόνη που βλέπετε με προεπιλεγμένη γλώσσα τα <span style={{fontWeight: 'bold'}}>Αγγλικά</span><span style={{fontWeight: 'bold'}}> (1η φώτο)</span>.<br />
                    Στην συνέχεια πατάμε "AGREE" στους όρους χρήσης.<span style={{fontWeight: 'bold'}}> (2η φώτο)</span>
                </div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step1/1.png"}, {original: "assets/images/primer-pos-steps/setupDevice/step1/2.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Σύνδεση σε Δίκτυο Wi-Fi</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Επιλέγουμε την σύνδεση σε Wi-Fi και συνδέουμε την συσκευή στο δίκτυο με όνομα <span style={{fontWeight: 'bold'}}>Primer-Emron-Wi-Fi_Guest</span>.</div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step2/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Μη αντιγραφή δεδομένων</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Στην επόμενη οθόνη πατάμε το κουμπί <span style={{fontWeight: 'bold'}}>Dont Copy</span>.</div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step3/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Σύνδεση σε Gmail</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Στην επόμενη οθόνη συνδέουμε στην συσκευή το Gmail με όνομα χρήστη <span style={{fontWeight: 'bold'}}>shipping@primer.gr</span> και με τον γνωστό κωδικό. <br />
                    Στην συνέχεια πατάμε "I agree" στους όρους χρήσης.
                </div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step4/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Απενεργοποίηση Google Services</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Στην επόμενη οθόνη απενεργοποιούμε με την αντίστοιχη επιλογή όλες τις λειτουργίες που αναφέρει.</div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step5/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Skip Screen Lock</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Στην επόμενη οθόνη πατάμε το κουμπί <span style={{fontWeight: 'bold'}}>"Skip"</span> και στην συνέχεια <span style={{fontWeight: 'bold'}}>"Skip Anyway"</span>.</div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step6/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Skip Google Assistant - Pay - Account</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Στις επόμενες 3 οθόνες κάνουμε scroll και πατάμε το κουμπί <span style={{fontWeight: 'bold'}}>"Skip"</span>. <br />
                    Στην 4η και τελευταία οθόνη πατάμε το κουμπί <span style={{fontWeight: 'bold'}}>"No thanks"</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/setupDevice/step7/1.png"},
                    {original: "assets/images/primer-pos-steps/setupDevice/step7/2.png"},
                    {original: "assets/images/primer-pos-steps/setupDevice/step7/3.png"},
                    {original: "assets/images/primer-pos-steps/setupDevice/step7/4.png"},
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Ενεργοποίηση Remote Assistance</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε την εφαρμογή <span style={{fontWeight: 'bold'}}>Remote Assistance</span> και ενεργοποιούμε την επιλογή <span style={{fontWeight: 'bold'}}>Unattend</span>
                </div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step8/1.png"}]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Αναμονή Εγκατάστασης Εφαρμογών</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>Η συσκευή έχει ενεργοποιηθεί πλέον με το σύστημα της SUNMI. Αναμένετε να εγκατασταθούν αυτόματα οι εφαρμογές
                     <span style={{fontWeight: 'bold'}}> Primer Launcher</span> και
                     <span style={{fontWeight: 'bold'}}> eΤαμειακή</span> και προχωρήστε στο επόμενο βήμα.
                </div>,
                images: [{original: "assets/images/primer-pos-steps/setupDevice/step9/1.png"}]
            },
        ]
    },
    configureLauncher: {
        id: 2,
        title: "Ρύθμιση Primer Launcher",
        icon: <HiRocketLaunch size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Ενεργοποίηση Developer Options</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε τις <span style={{fontWeight: 'bold'}}>Ρυθμίσεις</span> της συσκευής και μεταβαίνουμε στην οθόνη <span style={{fontWeight: 'bold'}}>About Device (1η φώτο)</span>.<br />
                    Πατάμε <span style={{fontWeight: 'bold'}}>7 φορές το πεδίο Build Number</span> μέχρι να μας δείξει το μήνυμα <span style={{fontWeight: 'bold'}}>You are now a developer (2η φώτο)</span>.<br />
                    Πηγαίνουμε πίσω και ανοίγουμε την σελίδα <span style={{fontWeight: 'bold'}}>System → Developer Options (3η φώτο)</span>.
                    Τέλος ενεργοποιούμε την επιλογή <span style={{fontWeight: 'bold'}}>USB Debugging (4η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureLauncher/step1/1.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step1/2.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step1/3.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step1/4.png"},
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>ADB Grant Permission</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Συνδέουμε την Συσκευή με τον υπολογιστή μέσω USB και πατάμε <span style={{fontWeight: 'bold'}}>Allow (1η φώτο)</span> στο Pop-Up που θα εμφανιστεί στην συσκευή. <br />
                    Ανοίγουμε το Command Prompt και τρέχουμε την εντολή:<br /> <span style={{fontWeight: 'bold'}}>adb shell pm grant com.primer.primerlauncher android.permission.WRITE_SECURE_SETTINGS (2η φώτο)</span> <br/>
                    <span style={{fontWeight: 'bold', color: "red"}}>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ! ΚΛΕΙΝΟΥΜΕ ΤΑ DEVELOPER OPTIONS!</span>
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureLauncher/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step2/2.png"},
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Allow All Permissions</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε την εφαρμογή <span style={{fontWeight: 'bold'}}>Primer Launcher και πατάμε Allow</span> σε όλα τα permissions που μας ζητά (Βλέπε φώτο).<br />
                    <span style={{fontWeight: 'bold'}}>1) Location Accuracy</span><br />
                    <span style={{fontWeight: 'bold'}}>2) Battery Optimization</span><br />
                    <span style={{fontWeight: 'bold'}}>3) Notification Management</span><br />
                    <span style={{fontWeight: 'bold'}}>4) Default home App</span><br />
                    <span style={{fontWeight: 'bold'}}>5) VPN Connection</span>
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureLauncher/step3/1.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step3/2.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step3/3.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step3/4.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step3/5.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Clean Up Configuration</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Ανοίγουμε το notification σχετικά με το Android Setup και το ολοκληρώνουμε.<br />
                    2) Ανοίγουμε Ρυθμίσεις και ελέγχουμε για ενημερώσεις.<br />
                    3) Ανοίγουμε Play Store και ελέγχουμε για ενημερώσεις.<br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureLauncher/step4/1.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step4/2.png"},
                    {original: "assets/images/primer-pos-steps/configureLauncher/step4/3.png"}
                ]
            },
        ]
    },
    configureSimAndGeneralSettings: {
        id: 3,
        title: "Παραμετροποίηση SIM και Γενικών Ρυθμίσεων",
        icon: <GrSystem size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Παραμετροποίηση SIM APN</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε τις Ρυθμίσεις και μεταβαίνουμε στην σελίδα:
                    <span style={{fontWeight: 'bold'}}> Network & Internet → Mobile Network → Access Point Names → Vodafone</span><br />
                    Στο πεδίο APN καταχωρούμε την τιμή <span style={{fontWeight: 'bold'}}>primer.iot</span> και στην συνέχεια πατάμε <span style={{fontWeight: 'bold'}}>Save</span> στο επάνω μενού με τις 3 τελείες.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/1.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/2.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/3.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/4.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/5.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step1/6.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Απενεργοποίηση Play Protect και Find Hub</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε τις Ρυθμίσεις και μεταβαίνουμε στην σελίδα:<span style={{fontWeight: 'bold'}}> Security. (1η φώτο)</span><br />
                    Πατάμε το <span style={{fontWeight: 'bold'}}> Google Play Protect και απενεργοποιούμε το App Scanning. (2η φώτο)</span><br />
                    Πηγαίνουμε πίσω και πατάμε το <span style={{fontWeight: 'bold'}}>Find Hub και απενεργοποιούμε την επιλογή. (3η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step2/2.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step2/3.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Απενεργοποίηση Google Location Services</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε τις Ρυθμίσεις και μεταβαίνουμε στην σελίδα:<span style={{fontWeight: 'bold'}}> Location. (1η-2η φώτο)</span><br />
                    Πατάμε το <span style={{fontWeight: 'bold'}}> Earthquake alerts και απενεργοποιούμε την επιλογή. (3η φώτο)</span><br />
                    Πηγαίνουμε πίσω και πατάμε το <span style={{fontWeight: 'bold'}}>Emergency Location Services και απενεργοποιούμε την επιλογή. (4η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step3/1.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step3/2.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step3/3.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step3/4.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Απενεργοποίηση Account Sync And Usage</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε τις Ρυθμίσεις και μεταβαίνουμε στην σελίδα:<span style={{fontWeight: 'bold'}}> Accounts. (1η φώτο)</span><br />
                    Απενεργοποιούμε την επιλογή <span style={{fontWeight: 'bold'}}> Automatically Sync Data. (2η φώτο)</span><br />
                    Πηγαίνουμε πίσω και μεταβαίνουμε στην σελίδα:<span style={{fontWeight: 'bold'}}>Digital Wellbeing (3η φώτο)</span> και πατάμε την επιλογή<span style={{fontWeight: 'bold'}}> Manage Data (4η φώτο)</span>.
                    Απενεργοποιούμε την επιλογή <span style={{fontWeight: 'bold'}}>Daily Device Usage (5η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step4/1.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step4/2.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step4/3.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step4/4.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step4/5.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Απενεργοποίηση Digital Assistant App</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                   1) Ανοίγουμε τις Ρυθμίσεις και μεταβαίνουμε στην σελίδα:<span style={{fontWeight: 'bold'}}> Apps → Default Apps. (1η-2η φώτο)</span><br />
                   2) Ανοίγουμε την ρύθμιση <span style={{fontWeight: 'bold'}}> Digital Assistant App (Default Digital Assistant App). (3η φώτο)</span><br />
                   3) Επιλέγουμε την τιμή <span style={{fontWeight: 'bold'}}>None (4η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step5/1.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step5/2.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step5/3.png"},
                    {original: "assets/images/primer-pos-steps/configureSimAndGeneralSettings/step5/4.png"}
                ]
            }
        ]
    },
    testDevice: {
        id: 4,
        title: "Δοκιμή Λειτουργιών Συσκευής",
        icon: <TbTestPipe size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Device Health Check</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε την εφαρμογή<span style={{fontWeight: 'bold'}}> POS Steward. (1η φώτο)</span><br />
                    Τρέχουμε το ΤΕΣΤ για την καλή λειτουργία όλων των εξαρτημάτων της συσκευής πατώντας το κουμπί <span style={{fontWeight: 'bold'}}> Device Health Check. (2η φώτο)</span><br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/testDevice/step1/1.png"},
                    {original: "assets/images/primer-pos-steps/testDevice/step1/2.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Έλεγχος eΤαμειακής και Εκτυπωτή</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ανοίγουμε την εφαρμογή<span style={{fontWeight: 'bold'}}> eΤαμειακή</span> και προσθέτουμε την <span style={{fontWeight: 'bold'}}>Ελληνική Γλώσσα στο πληκτρολόγιο. (1η-2η φώτο)</span><br />
                    Καταχωρούμε τα credentials <span style={{fontWeight: 'bold'}}>demo-demo-demo</span> και εκδίδουμε μια ΤΕΣΤ απόδειξη ελέγχοντας την λειτουργικότητα της εφαρμογής και του εκτυπωτή.<span style={{fontWeight: 'bold'}}>(3η φώτο)</span><br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/testDevice/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/testDevice/step2/2.png"},
                    {original: "assets/images/primer-pos-steps/testDevice/step2/3.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Ενεργοποίηση και έλεγχος SIM</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ενεργοποιούμε την SIM αλλάζοντας την κατάσταση της σε <span style={{fontWeight: 'bold'}}> Active.Test</span> με το παρακάτω κουμπί.<br />
                    Κάνουμε <span style={{fontWeight: 'bold'}}>RESTART</span> την συσκευή και απενεργοποιούμε το Wi-Fi.<br />
                    Εκδίδουμε μια ΤΕΣΤ απόδειξη ελέγχοντας την λειτουργικότητα της SIM.<br />
                    <span style={{fontWeight: 'bold', color: "red"}}>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ! ΚΛΕΙΝΟΥΜΕ ΑΜΕΣΩΣ ΜΕΤΑ ΤΑ MOBILE DATA!</span>
                </div>,
                images: [{original: "assets/images/primer-pos-steps/testDevice/step3/1.png"}]
            }
        ]
    },
    setUpCredentialsAndInstallApps: {
        id: 5,
        title: "Καταχώρηση Credentials - Εγκατάσταση Εφαρμογών",
        icon: <TbPasswordUser size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Εισαγωγή κλειδιών eΤαμειακής</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Αποσυνδεόμαστε απο την εφαρμογή <span style={{fontWeight: 'bold'}}>eΤαμειακή (1η φώτο)</span>.<br />
                    2) Καταχωρούμε τα παρακάτω credentials<br /><span style={{fontWeight: 'bold'}}> (2η φώτο)</span>.<br />
                    3) Πατάμε <span style={{fontWeight: 'bold'}}>Ενεργοποίηση</span> για να βεβαιωθούμε ότι τα έχουμε βάλει σωστά και κλείνουμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}> (3η φώτο)</span>.<br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step1/1.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step1/2.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step1/3.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Εγκατάσταση Εφαρμογών Acquiring</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Ανοίγουμε την εφαρμογή <span style={{fontWeight: 'bold'}}>Play Store (1η φώτο)</span>.<br />
                    2) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>epay SoftPOS (2η φώτο)</span>.<br />
                    3) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>viva.com Terminal (3η φώτο)</span>.<br />
                    4) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>Worldline Smart POS (4η φώτο)</span>.<br />
                    5) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>tapXphone (5η φώτο)</span>.<br />
                    6) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>NBG Pay Tom (6η φώτο)</span>.<br />
                    7) Εγκαθιστούμε την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>EDPS Link (7η φώτο)</span>.<br />
                </div>,
                descriptionViva: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Ανοίγουμε την εφαρμογή <span style={{fontWeight: 'bold'}}>Play Store (1η φώτο)</span>.<br />
                    2) <span style={{fontWeight: 'bold', color: "red"}}>ΠΡΟΣΟΧΗ!</span> Εγκαθιστούμε <span style={{fontWeight: 'bold', color: "red"}}>ΜΟΝΟ</span> την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>viva.com Terminal (2η φώτο)</span>.<br />
                </div>,
                imagesViva: [
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/3.png"}
                ],
                descriptionEpay: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Ανοίγουμε την εφαρμογή <span style={{fontWeight: 'bold'}}>Play Store (1η φώτο)</span>.<br />
                    2) <span style={{fontWeight: 'bold', color: "red"}}>ΠΡΟΣΟΧΗ!</span> Εγκαθιστούμε <span style={{fontWeight: 'bold', color: "red"}}>ΜΟΝΟ</span> την εφαρμογή<br /><span style={{fontWeight: 'bold'}}>epay SoftPOS (2η φώτο)</span>.<br />
                </div>,
                imagesEpay: [
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/2.png"}
                ],
                images: [
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/2.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/3.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/4.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/5.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/6.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step2/7.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Άνοιγμα Εφαρμογών Acquiring</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Ανοίγουμε <span style={{fontWeight: 'bold'}}>ΌΛΕΣ τις εφαρμογές</span> που εγκαταστήσαμε στο προηγούμενο βήμα.<br />
                    2) Κάνουμε <span style={{fontWeight: 'bold'}}>ΑΠΟΔΟΧΗ</span> σε ότι άδεια ή όρους χρήσης μας ζητάει μέχρι να φτάσουμε στην σελίδα είσοδου λογαριασμού.<br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step3/1.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step3/2.png"},
                    {original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step3/3.png"}
                ],
                imagesViva: [{original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step3/1.png"}],
                imagesEpay: [{original: "assets/images/primer-pos-steps/setUpCredentialsAndInstallApps/step3/2.png"}],
            }
        ]
    },
    closePackage: {
        id: 6,
        title: "Τελικός Έλεγχος και Πακετάρισμα",
        icon: <PiPackageBold size={25} />,
        steps: [
            {
                title: <span style={{fontWeight: 'bold'}}>Τελικός Έλεγχος και Τερματισμός</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    Ελέγχουμε ΞΑΝΑ ότι τα <span style={{fontWeight: 'bold'}}>MOBILE DATA είναι ΚΛΕΙΣΤΑ (1η φώτο)</span>.<br />
                    Κάνουμε <span style={{fontWeight: 'bold'}}>Τερματισμό Λειτουργίας</span> στην συσκευή <span style={{fontWeight: 'bold'}}>(2η φώτο)</span>.
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/closePackage/step1/1.png"},
                    {original: "assets/images/primer-pos-steps/closePackage/step1/2.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>Τοποθέτηση Εξαρτημάτων στην Συσκευασία</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Τοποθετούμε τον φορτιστή και το καλώδιο φόρτισης όπως δείχνει η <span style={{fontWeight: 'bold'}}>1η φώτο</span> πίσω στην συσκευασία.<br />
                    2) Τοποθετούμε την συσκευή μέσα στο σακουλάκι της όπως δείχνει η <span style={{fontWeight: 'bold'}}>2η φώτο</span> και την βάζουμε μέσα στην συσκευασία <span style={{fontWeight: 'bold'}}>(3η φώτο)</span>.<br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/closePackage/step2/1.png"},
                    {original: "assets/images/primer-pos-steps/closePackage/step2/2.png"},
                    {original: "assets/images/primer-pos-steps/closePackage/step2/3.png"}
                ]
            },
            {
                title: <span style={{fontWeight: 'bold', wordBreak: 'normal', overflowWrap: 'break-word'}}>Τοποθέτηση Οδηγιών Χρήσης SUNMI και Primer</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    1) Τοποθετούμε τις οδηγίες χρήσης της συσκευής <span style={{fontWeight: 'bold'}}>(SUNMI)</span> όπως δείχνει η <span style={{fontWeight: 'bold'}}>1η φώτο</span> πίσω στην συσκευασία.<br />
                    1) Τοποθετούμε τις οδηγίες χρήσης της eΤαμειακής <span style={{fontWeight: 'bold'}}>(Primer)</span> όπως δείχνει η <span style={{fontWeight: 'bold'}}>2η φώτο</span> πάνω απο τις πρώτες οδηγίες.<br />
                    3) Κλείνουμε καλά και για <span style={{fontWeight: 'bold'}}>ΤΕΛΕΥΤΑΙΑ ΦΟΡΑ</span> την συσκευασία <span style={{fontWeight: 'bold'}}>(3η φώτο)</span>.<br />
                </div>,
                images: [
                    {original: "assets/images/primer-pos-steps/closePackage/step3/1.png"},
                    {original: "assets/images/primer-pos-steps/closePackage/step3/2.png"},
                    {original: "assets/images/primer-pos-steps/closePackage/step3/3.png"},
                ]
            },
            {
                title: <span style={{fontWeight: 'bold'}}>🎉Η συσκευή είναι έτοιμη προς αποστολή!🎉</span>,
                description: <div style={{wordBreak: 'normal', overflowWrap: 'break-word'}}>
                    <span style={{fontWeight: 'bold', color: "green"}}>ΤΑ ΚΑΤΑΦΕΡΕΣ!!!👌👏👌👏👌👏</span><br />
                    Πάρε μια βαθιά ανάσα και κάνε την προσευχή σου ότι ακολούθησες <span style={{fontWeight: 'bold'}}>ΌΛΑ</span> τα βήματα της παραμετροποιήσης και δεν θα ξαναδείς ποτέ την συσκευή που έχεις μπροστά σου.
                </div>,
                images: [{original: "assets/images/primer-pos-steps/closePackage/step4/1.png"}]
            }
        ]
    },
};